import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';



export function getContenidoListSuccess(contenido) {
  return {type: types.LOAD_CONTENIDO_LIST_SUCCESS, contenido};
}

export function getContenidoDetalle(id, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContenidoApi.getContenidoDetalle(id , token).then(contenido => {                  
                  dispatch(sinReducerSuccess(contenido));
                  return contenido;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function getContenidoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContenidoApi.getContenidoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(contenido => {                  
                  dispatch(getContenidoListSuccess(contenido));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getContendiosListSuccess(contenido) {
  return {type: types.LOAD_CONTENIDOSLIST_SUCCESS, contenido};
}

export function getContenidosList(idModulo, token) {
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContenidoApi.getContenidosList(idModulo, token).then(contenido => {      
                  dispatch(getContendiosListSuccess(contenido));
                  return contenido;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function saveFile(datos, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().ContenidoApi.saveFile(datos, token).then((foto) => {            
        dispatch(sinReducerSuccess(foto.descripcion));   
         return foto;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getContenidoSuccess(catalogo) {
  return {type: types.LOAD_CONTENIDO_SUCCESS, catalogo};
}

export function getContenido(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContenidoApi.getContenido(id, token).then(contenido => {   
        dispatch(getContenidoSuccess(contenido));
        return contenido;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getContenidoMouloSuccess(catalogo) {
  return {type: types.LOAD_MODULOCONTENIDO_SUCCESS, catalogo};
}

export function getContenidoConf(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ContenidoApi.getContenidoConf(id, token).then(contenido => {   
        dispatch(getContenidoMouloSuccess(contenido));
        return contenido;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(contenido) {
  return {type: types.SAVE_CONTENIDO_SUCCESS, contenido};
}


export function save(contenido, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContenidoApi.save(contenido, token).then(contenidoGuardado => {   
    dispatch(saveSuccess(contenidoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveConfig(contenido, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContenidoApi.saveConfig(contenido, token).then(contenidoGuardado => {   
    dispatch(saveSuccess(contenidoGuardado));
        return contenidoGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function saveTime(contenido, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ContenidoApi.saveTime(contenido, token).then(contenidoGuardado => {   
    dispatch(saveSuccess(contenidoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getContenidoComboSuccess(datos) {
  return {type: types.GET_CONTENIDOS_COMBO_SUCCESS, datos};
}

export function getContenidoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContenidoApi.getContenidoCombo(token).then(datos => {   
        
      dispatch(getContenidoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function getContenidoComboAndTipo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContenidoApi.getContenidoComboAndTipo(token).then(datos => {   
        
      dispatch(getContenidoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getArchivosDisponibles(tipo,token, prefijo) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ContenidoApi.getArchivosDisponibles(tipo, token, prefijo).then(datos => {   
        
      dispatch(sinReducerSuccess(datos));
        return datos;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(contenido) {
  return {type: types.BORRAR_CONTENIDO_SUCCESS, contenido};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContenidoApi.borrar(id, token ).then(contenido => {
               
                  dispatch(borrarSuccess(contenido));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(contenido) {
  return {type: types.ACTIVAR_CONTENIDO_SUCCESS, contenido};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ContenidoApi.activar(id, token).then(contenido => {
               
                  dispatch(activarSuccess(contenido));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos, filtrosCombo) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos,
        filtrosCombo
	}
  return {type: types.SET_FILTRO_CONTENIDO, filtro};
}



